<template>
  <div id="checkbox-wrapper" ref="checkbox-wrapper">
    <input type="checkbox" id="cbx" style="display: none;" v-model="checkbox" />
    <label ref="check" for="cbx" class="check">
      <svg width="18px" height="18px" viewBox="0 0 18 18">
        <path
          d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"
        ></path>
        <polyline points="1 9 7 14 15 4"></polyline>
      </svg>
    </label>
    <p class="checkbox-text" :style="textStyle" @click="checkbox = !checkbox">
      {{ $t(text) }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    height: {
      type: String,
      required: false,
      default: "21px"
    },
    width: {
      type: String,
      required: false,
      default: "21px"
    },
    text: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: [Boolean, Number],
      required: false,
      default: false
    },
    textStyle: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  mounted() {
    this.$refs["check"].style.height = this.height;
    this.$refs["check"].style.width = this.width;
  },
  data() {
    return {
      checkbox: this.value
    };
  },
  watch: {
    value() {
      this.checkbox = this.value;
    },
    checkbox() {
      this.$emit("input", this.checkbox);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#checkbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  .checkbox-text {
    cursor: pointer;
    margin-left: 10px;
  }
}

label {
  margin-bottom: 0 !important;
  padding-left: 0 !important;
}

.check {
  cursor: pointer;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  transform: translate3d(0, 0, 0);
}
.check svg {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke: #c8ccd4;
  stroke-width: 1.5;
  transform: translate3d(0, 0, 0);
  transition: all 0.2s ease;
}
.check svg path {
  stroke-dasharray: 60;
  stroke-dashoffset: 0;
}
.check svg polyline {
  stroke-dasharray: 22;
  stroke-dashoffset: 66;
}
.check:hover:before {
  opacity: 1;
}
.check:hover svg {
  stroke: $color-primary;
}
#cbx:checked + .check svg {
  stroke: $color-primary;
}
#cbx:checked + .check svg path {
  stroke-dashoffset: 60;
  transition: all 0.3s linear;
}
#cbx:checked + .check svg polyline {
  stroke-dashoffset: 42;
  transition: all 0.2s linear;
  transition-delay: 0.15s;
}
</style>
